import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import axios from 'axios';
import TweetEmbed from 'react-tweet-embed';
import YoutubeEmbed from 'react-youtube';
import TelegramEmbed from 'react-telegram-embed';
import {
  Icon,
  Input,
  Form,
  Message,
  Container,
  Divider,
  Image,
} from 'semantic-ui-react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import LimitsExceededModal from '../../components/limits-exceeded-modal';
import DyzioInstagramEmbed from '../../components/dyzio-instagram-embed';

import { extractAssetURLData } from '../../utils/asset-url-helper-service';

import FacebookEmbed from '../facebook-embed';
import ThemeSelector from '../../themes/theme-selector';


const helpLinkUrl = (<a
  href="http://help.dyzio.co/getting-started/how-to-find-trackable-asset-urls"
  target="_blank"
  rel="noopener noreferrer"
>
  <b>How to find trackable asset URLs</b>
</a>);

const noPadding = {
  padding: 0,
};

const previewBlockStyle = {
  color: '#666666',
  minHeight: 350,
  height: 'auto',
};

const platformColors = {
  twitter: '#00aced',
  facebook: '#3b5998',
  youtube: '#cc181e',
  instagram: '#cd486b',
};

const platformsObjects = {
  twitter: 'tweet',
  facebook: 'video, photo or post',
  youtube: 'youtube video',
  instagram: 'instagram post',
  tiktok: 'tiktok video',
  telegram: 'telegram post',
  external: 'asset',
};

const previewIconStyle = {
  marginTop: 150,
};

class AddAssetForm extends React.Component {
  constructor() {
    super();
    this.state = {
      inputValue: null,
      isLoading: false,
      isTweet: false,
      isFacebook: false,
      isInstagram: false,
      isYoutube: false,
      isTiktok: false,
      isTelegram: false,
      hasError: false,
      embedValue: null,
      embedId: null,
      isDuplicateEntry: false,
      isAddingAsset: false,
    };
  }

  componentDidMount() {
    if (this.input) this.input.focus();
  }

  onAssetUrlChanged = async (e, data) => {
    const { value } = data;
    const { platform, posts } = this.props;

    const details = extractAssetURLData(value);
    const existing = _.find(posts.data.posts, ['trackedAsset.assetURL', details && details.assetURL || '']);

    console.log(details);
    console.log(platform);
    console.log(value);

    if (existing) {
      this.setState({
        isDuplicateEntry: true,
      });
      return;
    }

    const state = this.state;

    this.setState({
      isLoading: true,
      embedValue: null,
      hasError: false,
    });

    if (!details || !details.platform || _.lowerCase(platform) !== _.lowerCase(details.platform)) {
      this.setState({
        hasError: !_.isEmpty(value),
        isLoading: false,
        embedValue: null,
        inputValue: null,
        isDuplicateEntry: false,
      });
    }

    switch (details.platform) {
    case 'FACEBOOK':
      state.isFacebook = true;
      state.isTweet = false;
      state.isInstagram = false;
      state.isYoutube = false;
      state.isTiktok = false;
      state.embedValue = details.assetURL;
      state.embedType = details.assetType;
      break;
    case 'TWITTER':
      state.isFacebook = false;
      state.isTweet = true;
      state.isInstagram = false;
      state.isYoutube = false;
      state.isTiktok = false;
      state.embedValue = details.assetId;
      break;
    case 'INSTAGRAM':
      state.isFacebook = false;
      state.isTweet = false;
      state.isInstagram = true;
      state.isYoutube = false;
      state.isTiktok = false;
      state.embedValue = details.assetURL;
      state.embedId = details.assetId;
      break;
    case 'YOUTUBE':
      state.isFacebook = false;
      state.isTweet = false;
      state.isInstagram = false;
      state.isYoutube = true;
      state.isTiktok = false;
      state.embedValue = details.assetId;
      break;
    case 'TIKTOK':
      state.isFacebook = false;
      state.isTweet = false;
      state.isInstagram = false;
      state.isYoutube = false;
      state.isTiktok = true;
      state.embedValue = details.assetURL;
      break;
    case 'TELEGRAM':
      state.isFacebook = false;
      state.isTweet = false;
      state.isInstagram = false;
      state.isYoutube = false;
      state.isTiktok = false;
      state.isTelegram = true;
      state.embedValue = details.assetURL;
      break;
    default:
      state.embedValue = null;
    }

    if (state.isTiktok) {
      const { assetId, handle } = details;
      const videoMetaUrl = `${process.env.REACT_APP_GET_TIKTOK}meta/user/${handle}/post/${assetId}`;
      try {
        const meta = await axios(videoMetaUrl);
        state.embedImage = _.get(meta.data, 'imageUrl');
        console.log(state.embedImage);
      } catch (err) {
        console.log(err);
        state.isLoading = false;
      }
    }

    state.isLoading = false;
    state.inputValue = details.assetURL;
    state.isDuplicateEntry = false;
    state.details = details;
    this.setState(state);

    console.log(state);
  }

  onFocus = e => e.target.select();

  onFormSubmit = () => {
    const { hasError, isLoading, previewUrl, embedValue, details } = this.state;
    const hasPost = previewUrl || embedValue;
    const canSubmit = !hasError && !isLoading;
    if (canSubmit && hasPost) {
      this.props.addAssetHandler(details);
    }
  }

  handleAddAsset = () => {
    this.setState({
      isAddingAsset: true,
    }, () => {
      const { details } = this.state;
      const { popupToggleHandler } = this.state;
      this.props.addAssetHandler(details);
    });
  }


  render() {
    const {
      platform,
      popupToggleHandler,
      isOverLimit,
    } = this.props;

    const {
      inputValue,
      hasError,
      isLoading,
      previewUrl,
      isTweet,
      isFacebook,
      isYoutube,
      isInstagram,
      isTiktok,
      isTelegram,
      embedValue,
      embedType,
      embedId,
      embedImage,
      isDuplicateEntry,
      isAddingAsset,
    } = this.state;

    const inputIconStyle = {
      color: platformColors[platform],
    };

    const inputLabel = {
      basic: true,
      content: <div><Icon name={platform} style={inputIconStyle} /> URL</div>,
    };

    const icon = isLoading ? 'refresh' : 'arrow circle outline up';

    const youtubeEmbedOpts = {
      color: 'white',
      width: '100%',
      showinfo: 1,
    };

    const assetTypeText = platformsObjects[platform];

    const { disableHelpLinks } = ThemeSelector.theme();
    const actionButtonIcon = isAddingAsset ? <Icon name="spinner" loading /> : <Icon name="add" />;

    if (isOverLimit) {
      return (<DyzioModal
        onClose={popupToggleHandler}
        onOpen={this.onOpen}
        onActionButtonClick={this.handleAddAsset}
        hasActionButton
        actionButtonContent={`Add ${assetTypeText}`}
        actionButtonIcon={actionButtonIcon}
        shouldDisableActionButton
        headerText={`Add a new ${assetTypeText} to your campaign`}
        size="tiny"
      >
        <LimitsExceededModal assetType="tracked asset" />
      </DyzioModal>);
    }

    return (
      <DyzioModal
        onClose={popupToggleHandler}
        onOpen={this.onOpen}
        onActionButtonClick={this.handleAddAsset}
        hasActionButton
        actionButtonContent={`Add ${assetTypeText}`}
        actionButtonIcon={actionButtonIcon}
        shouldDisableActionButton={hasError || isAddingAsset || isLoading || !(previewUrl || embedValue)}
        headerText={`Add a new ${assetTypeText} to your campaign`}
        size="tiny"
        hasFeedbackProvider={!disableHelpLinks}
        feedbackType="info"
        feedbackIcon="info circle"
        feedbackContent={helpLinkUrl}
      >
        { isDuplicateEntry &&
          <Message fluid error>
            This asset has already been added to the campaign.
          </Message>
        }
        <Form onSubmit={this.onFormSubmit}>
          <Form.Field>
            <Input
              fluid
              value={inputValue}
              label={inputLabel}
              labelPosition="left"
              style={noPadding}
              onFocus={this.onFocus}
              onChange={this.onAssetUrlChanged}
              ref={i => { this.input = i; }}
            />
          </Form.Field>
          <Divider />
          <Form.Field>
            <Container textAlign="center" style={previewBlockStyle}>
              { hasError && <div>
                <Icon name="minus circle" size="huge" style={previewIconStyle} />
                <br />
                <span>
                  <b>invalid { _.upperFirst(platformsObjects[platform]) } url.</b>
                </span>
              </div>
              }
              { !previewUrl && !embedValue && !hasError && <div>
                <Icon loading={isLoading} name={icon} size="huge" style={previewIconStyle} />
                <br />
                <span>
                  <b>
                    { isLoading ? 'please wait...' : `paste ${platformsObjects[platform]} url above` }
                  </b>
                </span>
              </div>
              }
              { !hasError && !isLoading && embedValue && isTweet && <TweetEmbed
                id={embedValue}
              />
              }
              { !hasError && !isLoading && embedValue && isInstagram &&

                <DyzioInstagramEmbed
                  assetId={embedId}
                />
              }
              { !hasError && !isLoading && embedValue && isFacebook && <FacebookEmbed
                url={embedValue}
                type={embedType}
              />
              }
              { !hasError && !isLoading && embedValue && isYoutube && <YoutubeEmbed
                videoId={embedValue}
                opts={youtubeEmbedOpts}
              />
              }
              { !hasError && !isLoading && embedValue && isTiktok &&
                <Image src={embedImage} size="medium" centered />
              }
              { !hasError && !isLoading && embedValue && isTelegram &&
                <TelegramEmbed src={embedValue} />
              }
            </Container>
          </Form.Field>
        </Form>
      </DyzioModal>
    );
  }
}

AddAssetForm.propTypes = {
  addAssetHandler: PropTypes.func.isRequired,
  popupToggleHandler: PropTypes.func.isRequired,
  platform: PropTypes.string.isRequired,
  posts: PropTypes.array,
  isOpen: PropTypes.bool.isRequired,
  isOverLimit: PropTypes.bool.isRequired,
};

AddAssetForm.defaultProps = {
  posts: { data: { posts: [] } },
};

export default AddAssetForm;



/** WEBPACK FOOTER **
 ** ./src/components/add-asset-form/index.js
 **/